export default "__VITE_ASSET__Nf56Uw2S__"